module.exports = __webpack_public_path__ + "static/media/sao-paulo.ec3bb154.svg";